export enum SliderTitles {
  LEARN_MORE = 'En savoir plus',
  LANDSCAPES_BTN = 'Paysages captivants de Catalogne ',
  CATALUNYA = 'Catalogne',
}
